var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{key:_vm.$route.path})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74d38f26","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/modulos/solicitacao-importacao-projeto/componentes/SolicitacaoImportacao.vue
// module id = 2152
// module chunks = 0